// import Alpine from "alpinejs";
import lenis from "./lenis.js";

function baseapp(){
	return{
		acknowledgement: true, 
		atTop: false,
		sideMenuOpen:false, 
		searchBarOpen:false,
        lastScrollPos: 0,
        isNavVisible: true,
        lenis:null,
        init(){
           lenis.on('scroll', (e) => {
            const currentScrollPos = e.scroll;
                if (currentScrollPos > this.lastScrollPos && currentScrollPos > 200) {
                    this.isNavVisible = false;
                } else {
                    this.isNavVisible = true;
                }
                this.lastScrollPos = currentScrollPos;
            });

            // Watch on sidemenu open
            this.$watch("sideMenuOpen",(value)=>{
                if(value == true){
                 lenis.stop()
                }else{
                  lenis.start();
                }
            })
        },
	}
};

document.addEventListener("alpine:init", () => {
	Alpine.data('baseapp', baseapp);
})
